import React, { FC } from 'react'
import { fetchAllClientData } from 'apis/client'
import { createNewBrowserPath, getCurrentBrowserPath } from 'lib/storeLocale/client'
import { setClientStorage } from 'store/middleware/client'
import { getCartData } from 'components/CartUrgencyBar/helper'
import Modal from 'components/SA/Modal/v2'
import { ModalComponentProps } from './Auth'
import styles from './Auth.module.scss'
import Close from 'svg/close-x.svg'
import Login from '../Forms/Login'

export const MODAL_NAME = 'prompt'

const PromptLoginModal: FC<ModalComponentProps> = (props) => {
  const { closeModal, resetPasswordModal, registerModal, updateSession } = props

  const handleSubmit = async () => {
    // Fetch Session and Cart data
    const { payload: allClientData, success } = await fetchAllClientData()

    if (!success) {
      console.error('Problem Fetching Session')
      return
    }

    setClientStorage(allClientData)
    await getCartData()
    const { cart, cookie, session } = allClientData
    const { countryCode } = cookie.userPreferences
    const urlPrefix = `en-${countryCode.toLowerCase()}`
    const newBrowserPath = createNewBrowserPath(urlPrefix)
    const currentBrowserPath = getCurrentBrowserPath()

    if (newBrowserPath !== currentBrowserPath) {
      window.location.href = newBrowserPath
      return
    }

    updateSession({ cart: cart.count || 0, cookie, session })
    closeModal()
  }

  return (
    <Modal
      name={MODAL_NAME}
      onCloseModal={closeModal}
      layout='standard'
      styleOverride={styles.authModal}
    >
      <>
        <Close onClick={closeModal} className={styles.closeIcon} />
        <Login
          message='You were logged out. Please log in to continue.'
          onClickRegister={() => {
            registerModal()
          }}
          onClickResetPassword={() => {
            resetPasswordModal()
          }}
          onSubmit={handleSubmit}
        />
      </>
    </Modal>
  )
}

export default PromptLoginModal
